export default __webpack_public_path__ + "static/media/azracan7.1373bef6.jpg";